"use strict";Object.defineProperty(exports, "__esModule", {value: true});























const patientChatAvatar = ({
  patientKey,
  currentUserKey,

  userSubscribersList,
  teamSubscribersList,

  layoutProps,
  renderUserAvatar,
  renderTeamAvatar,
  renderPatientAvatar,
  renderGroupAvatar,
}) => {
  const usersCount = userSubscribersList.length
  const teamsCount = teamSubscribersList.length

  const otherUserSubscribersList = userSubscribersList
    .filter(u => u.UserKey !== currentUserKey)

  // The viewer and the first team don't count: New chat sends to a patient
  // from the practice's team, which joins the chat without adding the
  // sender, and a stack there reads as "two patients". Everyone else
  // counts, so people in the same chat can see different avatars.
  if (!otherUserSubscribersList.length && teamsCount < 2) {
    return renderPatientAvatar({ patientKey, ...layoutProps }) 
  }

  const participantNumber = teamsCount + usersCount

  const getBackAvatar = () => {
    if (teamsCount) {
      return teamSubscribersList[0]
        ? renderTeamAvatar({
          teamKey: teamSubscribersList[0].TeamKey,
          participantNumber,
        })
        : null
    }
    // Never the viewer: the stack shows who else is in the chat.
    return otherUserSubscribersList[0]
      ? renderUserAvatar({
        userKey: otherUserSubscribersList[0].UserKey,
        participantNumber,
      })
      : null
  }

  return renderGroupAvatar({
    frontAvatar: renderPatientAvatar({ patientKey }),
    backAvatar: getBackAvatar(),
    ...layoutProps,
  }) 
}

exports. default = patientChatAvatar
